import Vue from 'vue'
import { $, $$ } from '../_utils'

const BASE_URl = process.env.BASE_URL
const SEARCH_PRODUCT_SALES_REP = process.env.SEARCH_PRODUCT_SALES_REP
Vue.component('vue-search-input', {
  template: '#vue-search-input-template',
  data() {
    return {
      searchText: '',
      scrollToElement: {},
    }
  },
  methods: {
    scrollToSearch() {
      this.scrollToElement = $('.show-results')
      if (this.scrollToElement)
        this.scrollToElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
    },
  },
  mounted() {
    this.scrollToSearch()
  },
})

const searchInputs = $$('#vue-search-input-wrapper')
window.addEventListener('DOMContentLoaded', () => {
  if (!searchInputs) return
  searchInputs.forEach(element => {
    new Vue({
      el: element,
    })
  })
})
